module.exports = __webpack_public_path__ + "static/media/elegir_metodo_run_serial_password_clave_unica.c2947413.svg";